import React, { PureComponent } from 'react';
import classNames from 'classnames';

import { translate as t } from '../../../translations';

/**
 * Renders two buttons that enable switching between `block` and `inline` modes.
 */
export class ModeSettings extends PureComponent {
    constructor(props) {
        super(props);

        this.setMode = this.setMode.bind(this);
    }

    /**
     * By clicking on a mode, change the parent value.
     *
     * @param {SyntheticEvent} evt The event triggering this method.
     */
    setMode(evt) {
        const { onChange, property } = this.props;

        onChange(evt.currentTarget.id, property, evt);
    }

    render() {
        const { current, modes } = this.props;

        return (
            <div flex-container="row">
                {modes.map(({ value, label, render }, index) => (
                    <div
                        key={value}
                        className={classNames(
                            `widget-style-mode widget-style-mode--${value}`,
                            current === value && 'widget-style-mode--is-active',
                        )}
                        flex-item="flex-item"
                        id={value}
                        role="button"
                        tabIndex={index}
                        onClick={this.setMode}
                        onKeyDown={this.setMode}
                    >
                        {render && render()}
                        <span className="widget-style-mode__type">{t(label)}</span>
                    </div>
                ))}
            </div>
        );
    }
}
